/**
 * Normalizes rating info from any casing (snake_case or camelCase) to camelCase.
 * This allows components to work with a consistent camelCase interface regardless
 * of the source data format.
 */
export const normalizeRatingInfo = (ratingInfo) => {
    return {
        numberOfRatings: ratingInfo.numberOfRatings ?? ratingInfo.number_of_ratings ?? 0,
        starRating: ratingInfo.starRating ?? ratingInfo.star_rating ?? null,
        oneStarCount: ratingInfo.oneStarCount ?? ratingInfo.one_star_count,
        twoStarCount: ratingInfo.twoStarCount ?? ratingInfo.two_star_count,
        threeStarCount: ratingInfo.threeStarCount ?? ratingInfo.three_star_count,
        fourStarCount: ratingInfo.fourStarCount ?? ratingInfo.four_star_count,
        fiveStarCount: ratingInfo.fiveStarCount ?? ratingInfo.five_star_count,
        promptCounts: ratingInfo.promptCounts ?? ratingInfo.prompt_counts,
    };
};
export const hasStarDistributionData = (ratingInfo) => {
    return (ratingInfo.oneStarCount !== undefined &&
        ratingInfo.twoStarCount !== undefined &&
        ratingInfo.threeStarCount !== undefined &&
        ratingInfo.fourStarCount !== undefined &&
        ratingInfo.fiveStarCount !== undefined);
};
export const computeStarDistribution = (ratingInfo) => {
    const total = ratingInfo.numberOfRatings || 0;
    const counts = [
        { label: '5', count: ratingInfo.fiveStarCount || 0 },
        { label: '4', count: ratingInfo.fourStarCount || 0 },
        { label: '3', count: ratingInfo.threeStarCount || 0 },
        { label: '2', count: ratingInfo.twoStarCount || 0 },
        { label: '1', count: ratingInfo.oneStarCount || 0 },
    ];
    return counts.map(({ label, count }) => ({
        label,
        count,
        percentage: total > 0 ? Math.round((count / total) * 100) : 0,
    }));
};
